module.exports = __webpack_public_path__ + "static/media/1-6-3.826b2098.png";